export const mode = {
  name: "visol"
};
